import { useEffect } from "react";
import {
    enableSyleHover,
    getDataByFetch,
    listener,
    loadStyles,
    qualifyOld,
    setContentPlayers,
    setPromedios,
    submitListener,
} from "./qualifyPlayer.js";

export const useOptaWidget = (nodoOpta, value, typeWidget, notaId) => {

    useEffect(() => {

        const widget = {
            sport: value?.sport ? value.sport : null,
            widgetType: value?.widget?.widget ? value.widget.widget : null,
            widgetName: value?.widget?.widgetName ? value.widget.widgetName : "",
            competitionId: value?.competition?._id ? value.competition._id : null,
            competitionName: value?.competition?.name ? value.competition.name : "",
            seasonId: value?.competition?.seasonId ? value.competition.seasonId : "",
            matchId: value?.match?._id ? value.match._id : null,
            //matchId: '2277794',
            matchName: value?.match?.name ? value.match.name : "",
            fixtureName: value?.fixture?.name ? value.fixture.name : "",
        };
        let teamId = value?.teamHome?._id || "";

        if (typeWidget === "puntualizarjugadores") {

            const PUNTUALIZAR_URL_BASE = process.env.NEXT_PUBLIC_RATING_PLAYERS;

            const optaDisabled = !widget.sport || !widget.widgetType || !widget.matchId;

            if (!optaDisabled) {

                const urlEndpointMatch = (location.protocol === 'http:')
                    ? `http://${PUNTUALIZAR_URL_BASE}`
                    : `https://${PUNTUALIZAR_URL_BASE}`;


                let userData = JSON.parse(localStorage.getItem("wads_userProfile"));
                if (!!userData && userData.hasOwnProperty("value")) {
                    userData = userData.value;
                }
                let userAuthStatusWO = "0";
                if (!!userData && userData.hasOwnProperty("subscriptionStatus")) {
                    userAuthStatusWO = (userData.subscriptionStatus == "subscribed") ? "2" : "1";
                }

                if (nodoOpta) {

                    const callback = (entries, observer) => {
                        entries.map(async (entry) => {
                            if (entry.isIntersecting) {

                                if (nodoOpta.current.innerHTML.trim().length) {
                                    observer.unobserve(nodoOpta.current);
                                    return;
                                }

                                //buscar el match               
                                const [match, promedios, players] = await Promise.all([
                                    getDataByFetch(`${urlEndpointMatch}/${widget.seasonId}/${widget.matchId}`),
                                    getDataByFetch(`${urlEndpointMatch}/${widget.seasonId}/${widget.matchId}${teamId ? `-${teamId}` : ''}/promedios`),
                                    getDataByFetch(`${urlEndpointMatch}/${widget.seasonId}/players`),
                                ]);

                                console.log({ match, promedios, players });

                                loadStyles();

                                if (!!match && match?.status === 'ACTIVO') {

                                    let playersTeam, filteredMatchPlayers;

                                    playersTeam = players.filter(player => !teamId || player.teamId == teamId);
                                    filteredMatchPlayers = match.players.filter(matchPlayer => 
                                        playersTeam.some(filteredPlayer => filteredPlayer.id === matchPlayer.id)
                                    );

                                    const { arrayQualifyPlayers, data_players } = setContentPlayers(filteredMatchPlayers, playersTeam);

                                    nodoOpta.current.innerHTML = `
                                    <div class="qualifyplayer_login" style="display:none;">Debes ingresar para puntuar</div>
                                    ${data_players}
                                    <div>
                                        <div class="qualifyplayer_login" style="display:none;">Debes ingresar para puntuar</div>
                                        <button id="qualifyplayer_submit" style="display:none;">Finalizar puntuación</button>
                                    </div>
                                    <div id="datawarning" style="color: red;"></div>                         
                                    `;

                                    if (userAuthStatusWO == "0") {
                                        document.getElementById('datawarning').style.display = "none";
                                        const buttonSubmit = document.querySelectorAll('.qualifyplayer_login');
                                        Array.from(buttonSubmit).forEach(b => {
                                            b.style.display = "block";
                                        });
                                    }

                                    const userId = (userData && typeof userData.id !== "undefined" && userData.id !== "") ? userData.id : "-2";
                                    let qualify = false;
                                    if (userAuthStatusWO !== "0") {
                                        console.log(`${urlEndpointMatch}/${widget.seasonId}/${widget.matchId}-${teamId}/user/${userId}`)
                                        if (teamId) {
                                            qualify = await getDataByFetch(`${urlEndpointMatch}/${widget.seasonId}/${widget.matchId}-${teamId}/user/${userId}`);
                                        } else {
                                            qualify = await getDataByFetch(`${urlEndpointMatch}/${widget.seasonId}/${widget.matchId}/user/${userId}`);
                                        }
                                        if (!qualify) {
                                            console.error("Fail get info user puntuación.");
                                        }
                                    }

                                    //console.log({ userAuthStatusWO, userId, qualify });

                                    if (nodoOpta.current.innerHTML.length && !!qualify && qualify.hasOwnProperty("status")) {

                                        if (qualify.status === true) {
                                            // SI puntuaste este partido.
                                            const average = (promedios?.status === true)
                                                ? promedios.data.players
                                                : [];
                                            qualifyOld(nodoOpta.current, filteredMatchPlayers, qualify, listener, average, playersTeam);
                                            setPromedios(match.players, average);
                                        } else {
                                            // NO puntuaste este partido.
                                            enableSyleHover();
                                            const nodosQualifyPlayerBody = Array.from(nodoOpta.current.querySelectorAll('.qualifyplayer_body'));
                                            if (nodosQualifyPlayerBody.length) {
                                                const average = (promedios?.status === true)
                                                    ? promedios.data.players
                                                    : [];
                                                nodosQualifyPlayerBody.forEach(element => {
                                                    element.addEventListener("click", listener, false);
                                                    element.arrayQualifyPlayers = arrayQualifyPlayers;
                                                    element.notaId = notaId;
                                                    element.userId = userId;
                                                    element.url = teamId 
                                                        ? `${urlEndpointMatch}/${widget.seasonId}/${widget.matchId}-${teamId}` 
                                                        : `${urlEndpointMatch}/${widget.seasonId}/${widget.matchId}`;
                                                    element.average = average;
                                                });
                                            }

                                            document.getElementById('datawarning').style.display = "none";

                                            //boton submit
                                            const buttonSubmit = document.getElementById('qualifyplayer_submit');
                                            buttonSubmit.style.display = "block";
                                            buttonSubmit.addEventListener("click", submitListener, false);
                                            buttonSubmit.paramEnable = false;
                                            buttonSubmit.paramArrayQualifyPlayers = arrayQualifyPlayers;
                                            buttonSubmit.paramNodoOpta = nodoOpta;
                                            buttonSubmit.paramMatchPlayers = match.players;
                                        }

                                    }

                                } else if (!!match && match?.status === 'DESACTIVADO') {

                                    let { data_players } = setContentPlayers(match.players, players, "off");

                                    nodoOpta.current.innerHTML = `
                                        ${data_players}                                              
                                        <div id="datawarning" style="color: red;">Partido finalizado.</div>                                       
                                        `;

                                    const average = (promedios?.status === true)
                                        ? promedios.data.players
                                        : [];

                                    const minCount = (promedios?.status === true)
                                        ? promedios.data.minCount
                                        : 0;

                                    setPromedios(match.players, average, 'on', minCount);

                                } else {
                                    console.error("Fail get info match.");
                                }

                            }
                        });
                    }

                    const options = {
                        rootMargin: '750px',
                        threshold: 1.0
                    }
                    const observer = new IntersectionObserver(callback, options);
                    observer.observe(nodoOpta.current);
                }

            }
        }

    }, [value]);

};